"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationDefault = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const hui_1 = require("@mit/hui");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const hui_2 = require("@mit/hui");
exports.validationDefault = {
    valid: true,
    validationText: "",
};
const RecordTestResultComponent = ({ person, showCalendar, peopleStore, actionText, callbackFn }) => {
    const now = new Date();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [show, setShow] = (0, react_1.useState)(false);
    const [result, setResult] = (0, react_1.useState)("");
    const [completedDate, setCompletedDate] = (0, react_1.useState)(moment());
    const [pageError, setPageError] = (0, react_1.useState)({ error: false, errorText: "" });
    const [testTime, setTestTime] = (0, react_1.useState)(moment());
    (0, react_1.useEffect)(() => {
        setResult("");
        setPageError({ error: false, errorText: "" });
        setCompletedDate(moment());
        setTestTime(moment());
        setIsLoading(false);
    }, [show]);
    const handleShow = () => {
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
    };
    const submitAndClose = () => {
        if (result != "") {
            setPageError({ error: false, errorText: "" });
            setIsLoading(true);
            let testDateTime = `${completedDate.format("YYYY-MM-DD")}T${testTime.format("HH:mm:ssZ")}`;
            MedicalApi_1.default
                .postSchedule(person.kerberosId, testDateTime, result)
                .then((response) => {
                MedicalApi_1.default
                    .fetchPersonTests()
                    .then((response) => {
                    if (response.items) {
                        peopleStore.setScheduleList(response.items);
                        peopleStore.setTestResultList(response.items);
                    }
                    // if (callbackFn) {
                    // 	callbackFn();
                    // }
                })
                    .catch((e) => {
                    setPageError({ error: true, errorText: e });
                });
                if (callbackFn) {
                    callbackFn();
                }
                handleClose();
            })
                .catch((e) => {
                setPageError({ error: true, errorText: e });
            })
                .finally(() => {
                setIsLoading(false);
            });
        }
        else {
            setPageError({ error: true, errorText: "Please complete all the fields and try again." });
        }
    };
    const updateCallback = (newValue) => {
        setCompletedDate(moment(newValue));
    };
    const handleChangeStartTime = (value) => {
        let valArr = value.split(":");
        setTestTime(moment({ hour: valArr[0], minute: valArr[1] }));
    };
    const handleChangeResult = (event) => {
        setResult(event.text);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_2.Button, { type: hui_2.ButtonType.TextNaked, icon: "calendar-plus", onClick: handleShow, text: actionText }), (0, jsx_runtime_1.jsx)(hui_2.Drawer, { contentAriaLabel: "Record Test Results", header: (0, jsx_runtime_1.jsx)(hui_2.Text, { content: `Record Test Results`, type: hui_2.TextType.Heading3, icon: "" }), type: hui_2.DrawerType.Right, themedColor: "medical", show: show, onClose: handleClose, size: hui_2.DrawerSize.Small, footer: [], contents: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [pageError.error && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Alert, Object.assign({ onClose: () => {
                                setPageError({ error: false, errorText: "" });
                            }, variant: "danger", dismissible: true }, { children: pageError.errorText }))), (0, jsx_runtime_1.jsx)("h4", Object.assign({ className: "mb-4" }, { children: person.name })), (0, jsx_runtime_1.jsx)(hui_2.GridContainer, { children: (0, jsx_runtime_1.jsxs)(hui_2.LayoutColumn, Object.assign({ colSize: 6 }, { children: [(0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: "testResults", className: "displayBlock" }, { children: "Test Result" })), (0, jsx_runtime_1.jsx)(hui_2.Dropdown, { id: `record_test_result`, onChange: handleChangeResult, value: result, text: "Select Test Result", name: "testResults", dropdownItems: [
                                            { icon: "", text: "Positive" },
                                            { icon: "", text: "Negative" },
                                            { icon: "", text: "Invalid" },
                                        ] }), (0, jsx_runtime_1.jsx)("div", { className: "mb-3" }), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: "start-date", className: "displayBlock" }, { children: "Date Tested" })), (0, jsx_runtime_1.jsx)(hui_2.CalendarInput, { placeholder: "MM/DD/YYYY", value: completedDate.format("YYYY-MM-DD"), onChange: updateCallback, id: "start-date" }), (0, jsx_runtime_1.jsx)("div", { className: "mb-3" }), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: "test-time", className: "displayBlock" }, { children: "Time Tested" })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(hui_1.TimePicker, { onChange: handleChangeStartTime, name: "testTime" }), (0, jsx_runtime_1.jsx)("div", { className: "mb-5" })] })) }), (0, jsx_runtime_1.jsx)(hui_2.ButtonBar, { type: hui_2.ButtonBarType.Padded, buttons: [
                                {
                                    icon: "",
                                    text: "Submit",
                                    isBusy: isLoading,
                                    state: isLoading ? hui_2.ButtonState.Disabled : hui_2.ButtonState.Enabled,
                                    type: hui_2.ButtonType.Primary,
                                    onClick: submitAndClose,
                                },
                                {
                                    icon: "",
                                    text: "Cancel",
                                    state: isLoading ? hui_2.ButtonState.Disabled : hui_2.ButtonState.Enabled,
                                    type: hui_2.ButtonType.Secondary | hui_2.ButtonType.Ghost,
                                    onClick: handleClose,
                                },
                            ] })] }) })] }));
};
const RecordTestResult = (0, mobx_react_1.inject)("peopleStore")((0, mobx_react_1.observer)(RecordTestResultComponent));
exports.default = RecordTestResult;
